import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { Participante } from '../Models/participante.model';
import { RespostaWebAPI } from '../Models/resposta-web-api.model';
import { UserToken } from '../Models/token.model';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class ParticipanteService {

    token: UserToken;
    private participante = new Participante();


    private domParser: DOMParser;

    constructor(private router: Router, private http: HttpClient) {
        this.domParser = new DOMParser();
    }

    post(model: Participante): Observable<any> {
        const body = JSON.stringify(model);
        let headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*'  });
        return this.http.post(`${environment.apiUrl}participante`, body, { headers: headers });
    }

    put(model: Participante): Observable<any> {
        const body = JSON.stringify(model);
        let headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*'  });
        return this.http.put(`${environment.apiUrl}participante`, body, { headers: headers });
    }

    get(id: number): Observable<any> {
        let headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*'  });
        return this.http.get<any>(`${environment.apiUrl}participante?id=${id}`, { headers: headers });
    }
}